// @flow

import React, { Component } from 'react'
import 'babel-polyfill'

type Props = {
  phoneNumber: string,
  sentPhoneNumber: string,
  sentSms: string,
  sendError: any,
  verificationCode: string,
  verifyError: any,
  confirmedPhone: boolean,
  onChangePhoneNumber: Function,
  onChangeVerifyCode: Function,
  onClickSendPhoneNumber: Function,
  onClickBackToPhoneNumber: Function,
  onClickMakeCall: Function,
  onClickSendVerifyCode: Function,
}

class PhoneVerificationView extends Component<Props> {
  render() {
    const {
      phoneNumber,
      sentPhoneNumber,
      sentSms,
      sendError,
      verificationCode,
      verifyError,
      confirmedPhone,
      onChangePhoneNumber,
      onChangeVerifyCode,
      onClickSendPhoneNumber,
      onClickBackToPhoneNumber,
      onClickMakeCall,
      onClickSendVerifyCode,
    } = this.props

    let completeStepNumber = 1
    if (sentPhoneNumber) {
      completeStepNumber = 2
    }
    if (confirmedPhone) {
      completeStepNumber = 3
    }

    const firstStepClassName = completeStepNumber >= 1 ? '' : ' not-yet'
    const secondStepClassName = completeStepNumber >= 2 ? '' : ' not-yet'
    const thirdStepClassName = completeStepNumber >= 3 ? '' : ' not-yet'

    return (
      <div>
        <p className="phone-verification__text">
          {i18n.t('phoneVerification.description')}
        </p>
        <span className="phone-verification__sub-txt">
          {i18n.t('phoneVerification.about.0')}
          <a
            href="https://help.spacemarket.com/hc/ja/articles/360001430928"
            target="_blank"
          >
            {i18n.t('phoneVerification.about.1')}
          </a>
          {i18n.t('phoneVerification.about.2')}
        </span>
        <div className="phone-verification__set">
          <div className="phone-verification__step clearfix">
            <p className={`phone-verification__step-numb${firstStepClassName}`}>
              1
            </p>
            <p
              className={`phone-verification__step-title${firstStepClassName}`}
            >
              {i18n.t('phoneVerification.step1.title')}
            </p>
            <div className="phone-verification__step-content">
              {completeStepNumber === 1 && (
                <div className="phone-verification__step-content-wrap">
                  <span className="phone-verification__sub-txt">
                    {i18n.t('phoneVerification.step1.subtext')}
                  </span>
                  <label>
                    <input
                      placeholder="0312345678"
                      type="text"
                      id="user_contact_tel"
                      className="form-text servicse-form-text"
                      value={phoneNumber}
                      onChange={onChangePhoneNumber}
                    />
                  </label>
                  {sendError && (
                    <p className="phone-verification__required">
                      <i className="fa fa-exclamation-circle" />
                      {sendError}
                    </p>
                  )}
                  <div className="phone-verification__btn_set">
                    <input
                      type="button"
                      className="button-blue"
                      onClick={onClickSendPhoneNumber}
                      value={i18n.t('phoneVerification.step1.sms')}
                    />
                    <p className="phone-verification__txt-link">
                      <a href="#" onClick={onClickMakeCall}>
                        <i className="fa fa-phone" />
                        {i18n.t('phoneVerification.step1.call')}
                      </a>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="phone-verification__step clearfix">
            <p
              className={`phone-verification__step-numb${secondStepClassName}`}
            >
              2
            </p>
            <p
              className={`phone-verification__step-title${secondStepClassName}`}
            >
              {i18n.t('phoneVerification.step2.title')}
            </p>
            <div className="phone-verification__step-content">
              {completeStepNumber === 2 && (
                <div className="phone-verification__step-content-wrap">
                  {sentSms ? (
                    <p className="phone-verification__disc">
                      <strong>{sentPhoneNumber}</strong>
                      {i18n.t('phoneVerification.step2.sms.desc.0')}
                      <strong>
                        {i18n.t('phoneVerification.step2.sms.desc.1')}
                      </strong>
                      {i18n.t('phoneVerification.step2.sms.desc.2')}
                    </p>
                  ) : (
                    <p className="phone-verification__disc">
                      {i18n.t('phoneVerification.step2.call.desc.0')}
                      <strong>
                        {i18n.t('phoneVerification.step2.call.desc.1')}
                      </strong>
                      {i18n.t('phoneVerification.step2.call.desc.2')}
                    </p>
                  )}
                  <div className="phone-verification__code-form">
                    <label>
                      <input
                        placeholder="01234"
                        type="text"
                        className="form-text servicse-form-text"
                        value={verificationCode}
                        onChange={onChangeVerifyCode}
                      />
                    </label>
                    <input
                      type="button"
                      className="button-blue"
                      value={i18n.t('phoneVerification.step2.verify')}
                      onClick={onClickSendVerifyCode}
                    />
                  </div>
                  {verifyError && (
                    <p className="phone-verification__required">
                      <i className="fa fa-exclamation-circle" />
                      {verifyError}
                    </p>
                  )}
                  <span className="phone-verification__sub-txt">
                    {sentSms
                      ? i18n.t('phoneVerification.step2.sms.subtext')
                      : i18n.t('phoneVerification.step2.call.subtext')}
                  </span>
                  <p className="phone-verification__txt-link">
                    <a href="#" onClick={onClickBackToPhoneNumber}>
                      {i18n.t('phoneVerification.step2.back')}
                    </a>
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="phone-verification__step clearfix">
            <p className={`phone-verification__step-numb${thirdStepClassName}`}>
              3
            </p>
            <p
              className={`phone-verification__step-title${thirdStepClassName}`}
            >
              {i18n.t('phoneVerification.step3.desc')}
            </p>
            {completeStepNumber === 3 && (
              <div className="phone-verification__step-content verify-done">
                <span className="phone-verification__number">
                  {sentPhoneNumber}
                </span>
                <p className="phone-verification__done-txt">
                  <span>
                    <i className="fa fa-check" />
                    {i18n.t('phoneVerification.step3.desc')}
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default PhoneVerificationView



// WEBPACK FOOTER //
// ./src/components/molecules/PhoneVerificationView/index.jsx